/**
 * Generated by '@kontent-ai/model-generator@6.5.1'
 */
export const taxonomies = {
    /**
     *  Harmonized Data Set
     */
    _harmonized_data_set_: {
        codename: '_harmonized_data_set_',
        id: 'aa976138-fe23-498d-a78e-0c0b65bcc5ef',
        externalId: undefined,
        name: ' Harmonized Data Set ',
        terms: {
            version_1: {
                codename: 'version_1',
                id: '24adc257-8d04-4f32-800e-134cf377289b',
                externalId: undefined,
                name: 'V1 HDS',
                terms: {}
            },
            version_2: {
                codename: 'version_2',
                id: '01a91fdd-a670-4234-8a31-ac591eae3d4d',
                externalId: undefined,
                name: 'V2 HDS',
                terms: {}
            }
        }
    }
} as const;
